import { useContext, useEffect, useCallback, useState } from "react";
import { PortalMainLayout } from "../../components/layout/portal-main-layout";
import { AuthorisedPage } from "../auth/authorised-page";
import { CognitoContext } from "../../contexts/cognito/cognito-provider";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PortalUserForm } from "../../components/users/edit-user";
import { CoreServiceSelector } from "../../services/core/service-selector";
import { AppRouteNames } from "../../routes/app-routes";
import { ToggleView } from "../../components/views/toggle-view";
import { useAppLoading } from "../../components/layout/app-loading-provider";
import { useToast } from "../../components/toast/toast-context";
import { PrimaryButton } from "../../components/form/primary-button";
import { BottomSheet } from "../../components/form/company-dropdown";
import AddUserBottomSheetContent from "../../components/users/add-user-bottomsheet-content";
import thumbsUpIcon from "../../assets/thumbsUpIcon.svg";
import { SecondaryButton } from "../../components/form/secondary-button";

export const AddUserPage = () => {
  const { success, error, info, warning, show } = useToast();
  const [open, setOpen] = useState(false);
  const { showLoading, hideLoading } = useAppLoading();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [unauthorised, setUnauthorised] = useState({ show: false });
  const { state, dispatch } = useContext(CognitoContext);

  const onSaveUser = useCallback(
    async (model) => {
      const service = CoreServiceSelector.GetUserManagementService(
        state.session
      );
      if (!service) return;

      showLoading();
      setData({ ...model });

      const result = await service.saveUserRecord(model).catch((err) => {
        hideLoading();
        if (err?.response?.status === 401) {
          setUnauthorised({ show: true });
        }
        setData({ ...model });
        error(err.response.data || "Something wrong happened");
      });

      if (result) {
        hideLoading();
        setOpen(true);
      }
    },
    [state.session, showLoading, hideLoading, error]
  );

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(data?.TempPassword || "");
    success("Password copied to clipboard");
  }, [data, success]);

  const handleClose = useCallback(() => {
    setOpen(false);
    navigate(AppRouteNames.usersList);
    setData({});
  }, [navigate]);

  return (
    <AuthorisedPage>
      <BottomSheet open={open} title=" " onClose={handleClose}>
        <AddUserBottomSheetContent
          data={data}
          onCopy={handleCopy}
          onClose={handleClose}
          success={success}
        />
      </BottomSheet>
      <PortalMainLayout isUnauthorised={unauthorised.show}>
        <div className="bg-black fixed left-1/2 -translate-x-1/2 top-0 z-50 h-20 !rounded-xl md:ml-[2.5rem] flex items-center w-full px-4 justify-between">
          <div className="md:pl-20">
            <span className="text-white font-headings-primary ml-2 text-xl">
              Create a new user
            </span>
          </div>
          <div className="md:pr-8 ">
            <Link to="/users-list" className="flex items-center text-white ">
              <i className="bi bi-x-lg"></i>
            </Link>
          </div>
        </div>
        <div className="space-y-4 w-full md:w-3/4 mx-auto my-8 max-w-[640px] md:px-4 mt-[10vh] ">
          <PortalUserForm isNew={true} data={data} onSave={onSaveUser} />
        </div>
      </PortalMainLayout>
    </AuthorisedPage>
  );
};
